export const PageHero = ({ overline, title, lead, image }) => {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-44 pb-24 md:pt-52 md:pb-32 overflow-hidden bg-brand-sage/40"
    >
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage: image ? `url(${image})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.18,
        }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-xs uppercase tracking-[0.3em] font-semibold text-brand-leaf mb-6 flex items-center gap-3">
          <span className="w-10 h-px bg-brand-gold" />
          {overline}
        </div>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-brand-forest leading-[1.02] max-w-4xl">
          {title}
        </h1>
        {lead && (
          <p className="mt-8 max-w-2xl text-lg md:text-xl text-brand-mute leading-relaxed">
            {lead}
          </p>
        )}
      </div>
    </section>
  );
};
